module.exports = __webpack_public_path__ + "static/media/oo.a7f51c03.jpg";